import React from "react";
import ConfirmDocuments from "../../views/ConfirmDocuments/ConfirmDocuments";
import UploadService from "../../services/UploadService";

const ConfirmDocumentsIE = () => {
    return <ConfirmDocuments uploadAction={UploadService.uploadStatementIE}/>
}
export default ConfirmDocumentsIE;
